import { Injectable } from "@angular/core";
import { Http, Response, Headers } from "@angular/http";
import { Globals } from "../../globals"
import "rxjs/add/operator/map";
import * as CryptoJS from 'crypto-js';

@Injectable()
export class AuthenticationService {
    conversionEncryptOutput: string;
    constructor(private http: Http, private _global: Globals) {
    }

    login(email: string, password: string) {
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(this._global.HOST + '/user/tokenizeuser', { email: email, password: password }, httpOptions)
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let user = response.json();
                if (user && user.payload) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user.payload));
                    let dataUser = JSON.stringify({
                        email: email,
                        password: password,
                        sucursal: user.sucursal,
                        admin: user.admin,
                        id_user: user.id
                    });
                    this.conversionEncryptOutput = CryptoJS.AES.encrypt(dataUser, this._global.key_aes).toString();
                    localStorage.setItem('auth', this.conversionEncryptOutput);
                    //this.conversionDecryptOutput = CryptoJS.AES.decrypt(this.conversionEncryptOutput, this._global.key_aes).toString(CryptoJS.enc.Utf8);

                }
                return user;
            });
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/authentication.service.ts